export const useEnvs = () => {
  const runtimeConfig = useRuntimeConfig()
  const url = useRequestURL()

  const recaptchaKey = computed<string>(() => runtimeConfig.public.fecRecaptchaKey)
  const fecApiKey = computed<string>(() => runtimeConfig.public.fecApiKey)
  const googleMapsApiKey = computed<string>(() => runtimeConfig.public.fecGoogleMapsApiKey)
  const cdnUrl = computed<string>(() => runtimeConfig.public.fecCdn)
  const userCentricsId = computed<string>(() => runtimeConfig.public.userCentricsSettingsId)
  const forceExternalLinks = computed<boolean>(() => {
    // we allow access to the internal pages from the nuxt server
    // qanuxt, devnuxt, pnuxt are the internal domains
    if (url.host.match(/nuxt/)) {
      return false
    }

    return runtimeConfig.public.fecForceExternalLinks
  })

  const appEnv = computed<string>(() => runtimeConfig.public.appEnv)
  const cmsToken = computed<string>(() => runtimeConfig.public.cmsToken)
  const fecV2SentryDsn = computed<string>(() => runtimeConfig.public.fecV2SentryDsn)

  const isDev = computed<boolean>(() => appEnv.value === 'dev')
  const isQa = computed<boolean>(() => appEnv.value === 'qa')
  const isProd = computed<boolean>(() => appEnv.value === 'prod')

  const isLegacy = computed<boolean>(() => {
    return !['nuxt', 'localhost'].some(hostname => url.hostname.includes(hostname))
  })

  const logEnvs = () => {
    if (isDev.value || isQa.value) {
      onShowLogs(() => {
        console.info(
          '--- Environment Variables Summary ---',
          '\nrecaptchaKey:', recaptchaKey.value,
          '\nfecApiKey:', fecApiKey.value,
          '\ngoogleMapsApiKey:', googleMapsApiKey.value,
          '\ncdnUrl:', cdnUrl.value,
          '\nforceExternalLinks:', forceExternalLinks.value,
          '\nappEnv:', appEnv.value,
          '\ncmsToken:', cmsToken.value,
          '\nfecV2SentryDsn:', fecV2SentryDsn.value,
          '\n-------------------------------------',
        )
      })
    }
  }

  return {
    logEnvs,
    recaptchaKey,
    fecApiKey,
    googleMapsApiKey,
    cdnUrl,
    forceExternalLinks,
    appEnv,
    cmsToken,
    isDev,
    isQa,
    isProd,
    isLegacy,
    userCentricsId,
    fecV2SentryDsn,
  }
}
